module.exports = __webpack_public_path__ + "images/spoiler-71321e2b48ea6b8c9e084eebf7604321.png";